import { mainColor, UNIT } from '../../constants/theme';

export const styles = () => ({
  root: {
    width: '100%',
    marginBottom: UNIT * 0.9375,
    marginTop: UNIT
  },
  title: {
    flexBasis: '21%',
    fontWeight: 'bolder',
    textAlign: 'center',
    color: mainColor.colorBlackLight,
    fontSize: UNIT * 0.875
  },
  fab: {
    backgroundColor: `rgba(${mainColor.rgb}, 0.8)`,
    '&:hover': {
      backgroundColor: `rgba(${mainColor.rgb}, 1)`
    }
  },
  printers: {
    fontSize: UNIT * 0.875,
    color: 'gray',
    textAlign: 'center',
    alignSelf: 'center'
  },
  progress: {
    margin: UNIT * 5,
    textAlign: 'center',
    color: mainColor.secondaryColor
  }
});
